import { create } from 'zustand';

interface FixedCardState {
  component: string;
  symbol: string;
  setComponent: (name: string) => void;
  setSymbol: (code: string) => void;
  clearFixedCard: () => void;
}

const useFixedCard = create<FixedCardState>(set => ({
  component: '',
  symbol: '',
  setComponent: name => set(() => ({ component: name })),
  setSymbol: code => set(() => ({ symbol: code })),
  clearFixedCard: () => set(() => ({ component: '', symbol: '' }))
}));

export default useFixedCard;
